module.exports = __webpack_public_path__ + "static/pid-ug-2-en-createauthcode-198aeb08d6bb840b31b13e891e2e607f.png";